import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { WhatsAppConfigService } from 'src/app/private/services/whatsappconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateWhatsappConfigComponent } from "../create-whatsapp-config/create-whatsapp-config.component";
import { DeleteWhatsappConfigComponent } from "../delete-whatsapp-config/delete-whatsapp-config.component";

@Component({
  selector: 'app-whatsapp-config',
  imports: [SharedModule, CreateWhatsappConfigComponent, DeleteWhatsappConfigComponent],
  templateUrl: './whatsapp-config.component.html',
  styleUrl: './whatsapp-config.component.scss'
})
export class WhatsappConfigComponent {
  @Input() clientId!: string;
  whatsappConfigs: any[] = [];
  totalRecords = 0;
  rows = 10;
  loading = true;

  displayAddModal = false;
  showEditConfig = false;
  showDeleteConfig = false;
  configDataToEdit: any = null;

  configActionItem: MenuItem[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Config',
          icon: 'pi pi-fw pi-pencil',
          command: () => (this.showEditConfig = true),
        },
        {
          label: 'Delete Config',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => (this.showDeleteConfig = true),
        },
      ],
    },
  ];

  constructor(private whatsappConfigService: WhatsAppConfigService) {}


  openAddModal() {
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
  }

  setConfigData(data: any) {
    this.configDataToEdit = data;
  }

  loadConfigs(event: any): void {
    this.loading = true;

    const payload = {
      page: 0,
      limit: 100,
      where: {
        client_id: this.clientId,
      },
      order: {
        col: '"client_whatsapp_config"."updatedAt"',
        dir: 'DESC',
      },
    };

    this.whatsappConfigService.getAllWhatsAppConfigs(payload).subscribe({
      next: (data) => {
        this.whatsappConfigs = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading WhatsApp configs:', err);
        this.loading = false;
      },
    });
  }

  reload() {
    this.loadConfigs({ first: 0, rows: this.rows });
  }
}
